
import Home3 from '../views/PharmacyBigData/HomeView3.vue'


export default [
  {
    path: '/home3',
    component: Home3,
    redirect: '/pharmacy',
    children: [
      {  //实时大屏
        path: '/pharmacy',
        name: 'pharmacy',
        component: () => import('../views/PharmacyBigData/Pharmacy_RealTime.vue'),
        meta: {
          title: '实时大屏'
        }

      },
      { //平台统计
        path: '/plane',
        name: 'plane',
        component: () => import('../views/PharmacyBigData/PlaneStatistics/Pharmacy_Plane.vue'),
        meta: {
          title: '平台统计'
        }
      },
      { //平台统计
        path: '/plane2',
        name: 'health2',
        component: () => import('../views/PharmacyBigData/PlaneStatistics/Pharmacy_Plane2.vue'),
        meta: {
          title: '平台统计'
        }
      },
      { //平台统计
        path: '/plane3',
        name: 'health3',
        component: () => import('../views/PharmacyBigData/PlaneStatistics/Pharmacy_Plane3.vue'),
        meta: {
          title: '平台统计'
        }
      },
      { //用户行为分析
        path: '/useraction',
        name: 'useraction',
        component: () => import('../views/PharmacyBigData/UserAction/Pharmacy_user.vue'),
        meta: {
          title: '用户行为分析'
        }
      },
      { //用户行为分析
        path: '/useraction2',
        name: 'useraction2',
        component: () => import('../views/PharmacyBigData/UserAction/Pharmacy_user2.vue'),
        meta: {
          title: '用户行为分析'
        }
      },
      { //客户终端分析
        path: '/client',
        name: 'client',
        component: () => import('../views/PharmacyBigData/pharmacy_Client.vue'),
        meta: {
          title: '客户终端分析'
        }
      },
      { //商品分析
        path: '/plarproduct',
        name: 'plarproduct',
        component: () => import('../views/PharmacyBigData/Products/Plarmacy_product.vue'),
        meta: {
          title: '商品分析',

        },
      },
      { //商品分析
        path: '/plarproduct2',
        name: 'plarproduct2',
        component: () => import('../views/PharmacyBigData/Products/Plarmacy_product2.vue'),
        meta: {
          title: '商品分析',

        },
      },
      { //商品分析
        path: '/plarproduct3',
        name: 'plarproduct3',
        component: () => import('../views/PharmacyBigData/Products/Plarmacy_product3.vue'),
        meta: {
          title: '商品分析',

        },
      },

      {//类目分析
        path: '/plarcategory',
        name: 'plarcategory',
        component: () => import('../views/PharmacyBigData/CategoryAnalysis/pharmacy_Category.vue'),
        meta: {
          title: '类目分析'
        }
      },

      {//类目分析
        path: '/plarcategory2',
        name: 'plarcategory2',
        component: () => import('../views/PharmacyBigData/CategoryAnalysis/pharmacy_Category2.vue'),
        meta: {
          title: '类目分析'
        }
      },
      {//区域分析
        path: '/plarregional',
        name: 'plarregional',
        component: () => import('../views/PharmacyBigData/pharmacy_Regional.vue'),
        meta: {
          title: '区域分析'
        }
      },
      { //产品流向分析
        path: '/plarflow',
        name: 'plarflow',
        component: () => import('../views/PharmacyBigData/ProductFlow/Pharmacy_flow.vue'),
        meta: {
          title: '产品流向分析'
        }
      },
      { //产品流向分析
        path: '/plarflow2',
        name: 'plarflow2',
        component: () => import('../views/PharmacyBigData/ProductFlow/Pharmacy_flow2.vue'),
        meta: {
          title: '产品流向分析'
        }
      },
      { //产品流向分析
        path: '/plarflow3',
        name: 'plarflow3',
        component: () => import('../views/PharmacyBigData/ProductFlow/Pharmacy_flow3.vue'),
        meta: {
          title: '产品流向分析'
        }
      }
    ]
  }
]


